export class Definition {
    headerDefinition: any;
    calendarDefinition: any;
    calendarOverlayDefinition: any;
    themeDefinition: any;
    footerDefinition: any;
    mediaHierarchyRef: any;
    calendarRef: any;
    totalsRef: any;
    headerRef: any;
    grandTotalsRef: any;
    mediaHierarchyDefinition: any;
    themeRef: any;
    restrictions: any;
    isDataLoaded: boolean;
    lastRenderedDateTime: Date;
}
